import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getDeviceOnlineRate, getAllStationOnlineRate} from '@apis'
import allEnergy from '@assets/img/all-energy.png'
import onlineEnergy from '@assets/img/online-energy.png'
import offlineEnergy from '@assets/img/offline-energy.png'
import warnEnergy from '@assets/img/warn-energy.png'
import WarningInfoBg from '@assets/img/realtimeBg.png'
import * as G2 from '@antv/g2'

const WarningInfo = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId, brokerId} = userInfo
    const [onlineRate, setOnlineRate] = useState(null)
    const [offlineRate, setOfflineRate] = useState(null)
  
    // 获取配电柜信息
    async function queryEnergyList() {
      const params = {
        brokerId,
        projectId
      }
      const res = projectId ? await getDeviceOnlineRate(params) : await getAllStationOnlineRate(params)
      if (res) {
        const onlinePercent = (res.online / (res.online+res.offline)).toFixed(4)
        const offlinePercent = 1 - onlinePercent
        const rateData = [
          {item: '在线', count: res.online, percent: Number(onlinePercent)},
          {item: '不在线', count: res.offline, percent: Number(offlinePercent)}
        ]
        setOnlineRate(res.online)
        setOfflineRate(res.offline)
        creatChat(rateData)
      }
    }

    function creatChat(data) {
      const chart = new G2.Chart({
        container: 'energy-container',
        autoFit: true,
        // height: 120,
      });
      chart.data(data);
      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });
      chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.7,
      });
      chart.tooltip({
        // showTitle: false,
        // showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
      });
      // 辅助文本
      chart
        .annotation()
        .text({
          position: ['50%', '50%'],
          content: data[0].percent*100+'%',
          style: {
            fontSize: 24,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: -10,
        })
        .text({
          position: ['50%', '50%'],
          content: '在线率',
          style: {
            fontSize: 14,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: 14,
        })
      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('item')
        .tooltip('item*percent', (item, percent) => {
          percent = percent * 100 + '%';
          return {
            name: item,
            value: percent,
          };
        });
      chart.legend({
        // position: 'left',
        itemName: {
          style: {
            fontSize: 12,
            fill: '#fff'
          }
        }
      })
  
      chart.interaction('element-active');
  
      chart.render();
    }

    useEffect(() => {
      queryEnergyList()
    }, [])

    return (
      <div className='ck-energy-online'>
        <div className='energy-title'>配电柜在线率</div>
        <img className='energy-img' src={WarningInfoBg}/>
        <div className='energy-item'>
          <div id='energy-container' className='ck-energy-chart'></div>
          <div className='ck-energy-num'>
            <div className='ck-allEnergy'>
              <img src={allEnergy}/>
              <div>总数</div>
              <div>{onlineRate+offlineRate}个</div>
            </div>
            <div className='ck-onlineEnergy'>
              <img src={onlineEnergy}/>
              <div>运行</div>
              <div>{onlineRate ? onlineRate : 0}个</div>
            </div>
            <div className='ck-offlineEnergy'>
              <img src={offlineEnergy}/>
              <div>离线</div>
              <div>{offlineRate ? offlineRate : 0}个</div>
            </div>
            <div className='ck-warnEnergy'>
              <img src={warnEnergy}/>
              <div>故障</div>
              <div>0个</div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default WarningInfo
